import { useEffect, useState } from 'react';

// Cookie / GDPR banner for the marketing surface. My Dyslexia Tools uses only
// essential cookies (Supabase auth session, Stripe checkout). No trackers, no
// advertising cookies. The visible "no tracking" statement IS the parent trust
// signal - it's the reason we bother showing this even though a strict reading
// of UK PECR would say we don't need consent for essential-only.
//
// Dismissal is stored in localStorage (essential cookie exception).
const DISMISS_KEY = 'mdt.cookieBannerDismissed.v1';

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.localStorage.getItem(DISMISS_KEY)) return;
    // Slight delay so the banner doesn't flash before the page renders.
    const t = window.setTimeout(() => setVisible(true), 300);
    return () => window.clearTimeout(t);
  }, []);

  function dismiss() {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(DISMISS_KEY, new Date().toISOString());
    }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookieBannerTitle"
      className="fixed bottom-3 left-3 right-3 sm:bottom-5 sm:left-5 sm:right-auto sm:max-w-md z-50 rounded-2xl bg-white border border-ink/10 shadow-2xl p-4 sm:p-5"
    >
      <p id="cookieBannerTitle" className="text-sm font-semibold text-ink mb-1.5">
        Essential cookies only
      </p>
      <p className="text-xs text-ink/70 leading-relaxed">
        We use a small number of essential cookies to keep you signed in and remember your settings. We do not
        use tracking, advertising, or third-party analytics cookies. See our{' '}
        <a href="/privacy" className="underline text-ink hover:text-accent transition">Privacy Policy</a>{' '}
        for full detail.
      </p>
      <button
        type="button"
        onClick={dismiss}
        className="mt-3 inline-flex items-center justify-center bg-accent text-white px-4 py-2 rounded-full text-xs font-medium hover:brightness-105 transition"
      >
        Got it
      </button>
    </div>
  );
}
